module.exports = __webpack_public_path__ + "img/451029.953830d8.png";